export default "__VITE_ASSET__jWaGaaTe__"